import { v4 as uuid } from 'uuid';

import { MESSAGES, ROLE } from '../../../constants';

export interface IGeneratedAnswerMessage {
  readonly id: string;
  readonly type: MESSAGES.ANSWER_GENERATION;
  readonly role: ROLE.BOT;
  readonly question: string;
  readonly answer: string;
  readonly usedArticlesInfo: Record<string, string>;
  readonly rm: false;
  readonly preventScroll?: boolean;
  readonly clientOnly?: boolean;
}

export const createGeneratedAnswerMessage = (data): IGeneratedAnswerMessage | undefined => {
  return {
    id: data.id ? data.id : uuid(),
    type: MESSAGES.ANSWER_GENERATION,
    role: ROLE.BOT,
    question: data.question,
    answer: data.answer,
    usedArticlesInfo: data.usedArticlesInfo,
    rm: false,
    clientOnly: data.clientOnly,
  };
};
